import "./banner.css";

export const Banner = ({ text }) => {
    return (
        text ?
        <div className="banner">
            <span>{text}</span>
            <span>{text}</span>
            <span>{text}</span>
        </div>
        : <></>
    );
}